// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdatePassword_wrap__4tI7V {
  padding: 24px 4px 40px;
  display: flex;
  justify-content: center;
}

.UpdatePassword_card__vN-ji {
  width: 100%;
  max-width: 560px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #E7E9F1;
  box-shadow: 0 10px 28px rgba(27, 37, 89, 0.06);
  overflow: hidden;
}

.UpdatePassword_cardHeader__ypbWh {
  position: relative;
  overflow: hidden;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  padding: 22px 28px;
}

.UpdatePassword_cardHeader__ypbWh::before {
  content: "";
  position: absolute;
  top: -40px;
  right: -20px;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}

.UpdatePassword_cardTitle__IxGaP {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #ffffff;
}

.UpdatePassword_cardSub__h\\+b-O {
  position: relative;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.78);
  margin-top: 4px;
}

.UpdatePassword_cardBody__hD3NZ {
  padding: 28px 28px 32px;
}

.UpdatePassword_formGroup__kWlrU {
  margin-bottom: 20px;
}

.UpdatePassword_label__nokM1 {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.UpdatePassword_input__8JsVK {
  width: 100%;
  padding: 11px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 14px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.UpdatePassword_input__8JsVK:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.UpdatePassword_errorText__T-WAT {
  color: #EF4444;
  font-size: 12px;
  margin-top: 6px;
  display: block;
}

.UpdatePassword_submitBtn__4J1jM {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  border: none;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  padding: 11px 26px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(76, 47, 179, 0.28);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.UpdatePassword_submitBtn__4J1jM:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(76, 47, 179, 0.34);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Update Password/UpdatePassword.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD","sourcesContent":[".wrap {\n  padding: 24px 4px 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.card {\n  width: 100%;\n  max-width: 560px;\n  background: #ffffff;\n  border-radius: 18px;\n  border: 1px solid #E7E9F1;\n  box-shadow: 0 10px 28px rgba(27, 37, 89, 0.06);\n  overflow: hidden;\n}\n\n.cardHeader {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  padding: 22px 28px;\n}\n\n.cardHeader::before {\n  content: \"\";\n  position: absolute;\n  top: -40px;\n  right: -20px;\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  pointer-events: none;\n}\n\n.cardTitle {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.cardSub {\n  position: relative;\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.78);\n  margin-top: 4px;\n}\n\n.cardBody {\n  padding: 28px 28px 32px;\n}\n\n.formGroup {\n  margin-bottom: 20px;\n}\n\n.label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 8px;\n}\n\n.input {\n  width: 100%;\n  padding: 11px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 14px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.input:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.errorText {\n  color: #EF4444;\n  font-size: 12px;\n  margin-top: 6px;\n  display: block;\n}\n\n.submitBtn {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 11px 26px;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 10px 22px rgba(76, 47, 179, 0.28);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.submitBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px rgba(76, 47, 179, 0.34);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `UpdatePassword_wrap__4tI7V`,
	"card": `UpdatePassword_card__vN-ji`,
	"cardHeader": `UpdatePassword_cardHeader__ypbWh`,
	"cardTitle": `UpdatePassword_cardTitle__IxGaP`,
	"cardSub": `UpdatePassword_cardSub__h+b-O`,
	"cardBody": `UpdatePassword_cardBody__hD3NZ`,
	"formGroup": `UpdatePassword_formGroup__kWlrU`,
	"label": `UpdatePassword_label__nokM1`,
	"input": `UpdatePassword_input__8JsVK`,
	"errorText": `UpdatePassword_errorText__T-WAT`,
	"submitBtn": `UpdatePassword_submitBtn__4J1jM`
};
export default ___CSS_LOADER_EXPORT___;
